/* unplugin-vue-components disabled */import { render } from "./article.vue?vue&type=template&id=f4b78cf6&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=f4b78cf6&scoped=true&lang=scss"
import "./article.vue?vue&type=style&index=1&id=f4b78cf6&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b78cf6"]])

export default __exports__